/**
 * Defines the keys and display metadata for fields required in a **vetted profile**.
 *
 * These fields must be completed for a candidate to appear in the **vetted section** of the Talent Database (b2b app).
 * Vetted profiles represent candidates who have been interviewed and verified by the recruitment team.
 */
export const vettedKeys = {

    'first-name': { label: 'First name', group: 'Candidate name' },
    'last-name': { label: 'Last name', group: 'Candidate name' },

    email: { label: 'Email', group: 'Email or Phone' },
    phone: { label: 'Phone', group: 'Email or Phone' },

    city: { label: 'City', group: 'Location' },
    country: { label: 'Country', group: 'Location' },

    cv: { label: 'CV', group: 'CV or Linkedin' },
    linkedin: { label: 'LinkedIn (Top section information)', group: 'CV or Linkedin' },

    'preferred-job-functions': { label: 'Preferred job function', group: 'Personal Details & Preferences' },
    'preferred-occupations': { label: 'Preferred occupation', group: 'Personal Details & Preferences' },
    'preferred-skills': { label: 'Preferred skills', group: 'Personal Details & Preferences' },
    'working-model': { label: 'Working model (remote/hybrid/on-site)', group: 'Personal Details & Preferences' },
    'net-salary': { label: 'Net salary expectation', group: 'Personal Details & Preferences' },
    'gross-salary': { label: 'Gross salary expectation', group: 'Personal Details & Preferences' },
    'notice-period': { label: 'Notice period', group: 'Personal Details & Preferences' },
    motivation: { label: 'Candidate motivation', group: 'Personal Details & Preferences' },

    // Misc
    'last-updated': { label: 'Updated in the last 12 months', group: 'Extra' }, // Not in vettedFieldKeys, excluded from loop
};


/**
 * Defines the keys and display metadata for fields that define **non-vetted profiles**.
 *
 * These are considered minimum acceptable fields for a candidate to appear in the Talent Database (b2b app),
 * but is not marked as vetted.
 */
export const nonVettedKeys = {
    'first-name': { label: 'First name', group: 'Candidate name' },
    'last-name': { label: 'Last name', group: 'Candidate name' },

    city: { label: 'City', group: 'Location' },
    country: { label: 'Country', group: 'Location' },

    cv: { label: 'CV', group: 'CV or Linkedin' },
    linkedin: { label: 'LinkedIn (Top section information)', group: 'CV or Linkedin' },

    'preferred-job-functions': { label: 'Preferred job function', group: 'Personal Details & Preferences' },
    'preferred-occupations': { label: 'Preferred occupation', group: 'Personal Details & Preferences' },
    'preferred-skills': { label: 'Preferred skills', group: 'Personal Details & Preferences' },
    'working-model': { label: 'Working model (remote/hybrid/on-site)', group: 'Personal Details & Preferences' },
    'job-type': { label: 'Job type', group: 'Personal Details & Preferences' },

    'work-experience': { label: 'One work experience with job  and company, start date', group: 'Experience Or Education' },
    'education': { label: 'One education with university, department and start date', group: 'Experience Or Education' },

    'net-salary': { label: 'Net salary expectation (>400)', group: 'Personal Details & Preferences' },

    // Misc
    'no-rps': { label: 'No recruitment processes', group: 'Extra' }, // Not in vettedFieldKeys, excluded from loop
    'last-updated': { label: 'Updated last 12 months or logged in last 6', group: 'Extra' }, // Not in vettedFieldKeys, excluded from loop
};


